import { getBreakpointMediaQueries } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { useSelector } from 'react-redux';
import { getIsEditingGridLayouts } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import StyleSheetProvider from 'layout-dnd-utils/grids/render/StyleSheetProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export default function StyleSheetProviderWrapper({
  children
}) {
  const isEditingGridLayouts = useSelector(getIsEditingGridLayouts);
  const breakpointMediaQueries = useSelector(getBreakpointMediaQueries);
  if (isEditingGridLayouts) {
    return /*#__PURE__*/_jsx(StyleSheetProvider, {
      breakpointMediaQueries: breakpointMediaQueries,
      children: children
    });
  }
  return children;
}